// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
})();

// Boost PFS bug: in onOpenAutocomplete the iOS-only touchend handler reads
// href from the SearchInput closure variable instead of the touched anchor,
// so every tap on iOS sets window.location to "undefined" → "/undefined".
// Intercept the touch in capture phase before Boost's target-phase handler.
// Track movement so a scroll/drag on the suggestion list isn't taken as a tap.
(function() {
	var SUGGESTION_SELECTOR = '.boost-pfs-search-suggestion-item a';
	var TAP_SLOP = 10; // px of movement still considered a tap
	var startX = 0, startY = 0, moved = false;

	document.addEventListener('touchstart', function(ev) {
		if (!ev.target || !ev.target.closest || !ev.target.closest(SUGGESTION_SELECTOR)) return;
		var touch = ev.touches[0];
		startX = touch.clientX;
		startY = touch.clientY;
		moved = false;
	}, true);

	document.addEventListener('touchmove', function(ev) {
		if (moved) return;
		var touch = ev.touches[0];
		if (!touch) return;
		if (Math.abs(touch.clientX - startX) > TAP_SLOP || Math.abs(touch.clientY - startY) > TAP_SLOP) {
			moved = true;
		}
	}, true);

	document.addEventListener('touchend', function(ev) {
		var t = ev.target;
		var a = t && t.closest && t.closest(SUGGESTION_SELECTOR);
		if (!a) return;
		// Always swallow the event — Boost's broken handler would otherwise navigate to /undefined.
		ev.preventDefault();
		ev.stopPropagation();
		ev.stopImmediatePropagation();
		if (moved) return; // it was a scroll/drag, not a tap
		var href = a.getAttribute('href');
		if (!href || href === 'javascript:;' || href.charAt(0) === '#') return;
		window.location.href = href;
	}, true);
})();